import { Box } from '@mui/material';
import { SearchKeyInput, SearchKeyInputItems } from '../../component/form/search-key-input.component';
import TableComponent, { HeadCell } from '../../component/table/table.component';
import i18n from '../../i18n';
import { DeliverectLogState } from './deliverect-log-state';
import { observer } from 'mobx-react-lite';

const ConnectProject = observer(({ useData }: { useData: DeliverectLogState }) => {
    // 表格顶部下拉框数组
    const selectFilterLists: SearchKeyInputItems[] = [
        {
            value: 'group_name',
            label: i18n.t('group_management_page_text_group'),
            type: 'TEXT'
        }, {
            value: 'restaurant_name',
            label: i18n.t('group_management_page_text_restaurant'),
            type: 'TEXT'
        }];

    // 已对接的应用表格头部数据
    const table_head_cell_project: HeadCell[] = [
        // 集团
        { id: 'group_name', label: i18n.t('group_management_page_text_group') },
        // 集团
        { id: 'group_id', label: i18n.t('group_management_page_text_group_identification_code') },
        // 餐厅
        { id: 'restaurant_name', label: i18n.t('group_management_page_text_restaurant'), },
        // 餐厅
        { id: 'string_id', label: i18n.t('restaurant_page_input_text_restaurant_identification_code'), },
        // room
        { id: 'room', label: 'room' },
        // socket_id
        { id: 'socket_id', label: 'Socket Id' },
        // IP
        {
            id: 'ip', label: 'IP', renderFunction: (item) => {
                return item?.detailed?.ip || ''
            }
        }
    ]
    return (
        <div>
            <Box sx={{
                marginTop: 2,
                marginBottom: 3,
            }}>
                <SearchKeyInput
                    items={selectFilterLists as SearchKeyInputItems[]}
                    conditions={useData.paramCondition}
                    onSearch={(value) => useData.setParamConditions(value)}
                    showConditionsBox
                />
            </Box>
            <TableComponent
                {...{
                    showChecked: 0,
                    list: useData.connectedProject,
                    isPagination: true,
                    headCellList: table_head_cell_project,
                    isTableLoading: useData.isTableLoading,
                    allCount: useData.connectedProject.length,
                    isUseFold: true,
                    extraClass: 'extraTable',
                }}
            />
        </div>
    )
})

export default ConnectProject;